import { __assign } from "tslib";
import { connect } from 'react-redux';
import { screenTransitionCompleted } from '../actionCreators';
import Screen from '../components/Screen';
import controlScroll from '../hocs/controlScroll';
import { getScreenStyles } from '../selectors/layout';
import { getPreviousScreenProps } from '../selectors/screen';
function mapStateToProps(state) {
    var props = getPreviousScreenProps(state);
    var scrollTop;
    if (props.isVisible) {
        (scrollTop = getScreenStyles(state).scrollTop);
    }
    return __assign(__assign({}, props), { scrollTop: scrollTop });
}
var mapDispatchToProps = function (dispatch) { return ({
    onAnimationComplete: function () {
        dispatch(screenTransitionCompleted({ isCurrent: false }));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(controlScroll(Screen));
